import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Switch } from "../ui/switch";
import { getConsent, saveConsent, applyTracking } from "../../lib/tracking";
import { useContent } from "../../lib/content";

export const CookieBanner = () => {
  const { tracking } = useContent();
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState(false);
  const [c, setC] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    const saved = getConsent();
    if (saved) setC(saved);
    else setOpen(true);
    applyTracking(tracking, saved);
    const onOpen = () => { setPrefs(true); setOpen(true); };
    window.addEventListener("open-cookie-prefs", onOpen);
    return () => window.removeEventListener("open-cookie-prefs", onOpen);
  }, [tracking]);

  const commit = (v) => { const s = saveConsent(v); setC(s); applyTracking(tracking, s); setOpen(false); setPrefs(false); };

  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="cookie-banner" initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-3 left-3 right-3 sm:right-auto sm:left-5 sm:bottom-5 z-[60] sm:max-w-md glass rounded-2xl p-5 shadow-2xl shadow-black/50">
          <p className="font-display-n font-bold text-white">Cookie e privacy</p>
          <p className="mt-2 text-[13px] text-slate-300 leading-relaxed">
            Usiamo cookie tecnici necessari e, solo con il tuo consenso, cookie di analisi e marketing per misurare le visite e le conversioni. <Link to="/privacy" className="underline">Leggi la policy</Link>.
          </p>
          {prefs && (
            <div className="mt-4 space-y-3 text-[13px]">
              <div className="flex items-center justify-between"><span className="text-slate-200">Necessari</span><span className="text-slate-400 font-mono text-[11px]">sempre attivi</span></div>
              <div className="flex items-center justify-between"><span className="text-slate-200">Analisi (GA4)</span><Switch data-testid="cookie-analytics-switch" checked={c.analytics} onCheckedChange={(v) => setC((x) => ({ ...x, analytics: v }))} /></div>
              <div className="flex items-center justify-between"><span className="text-slate-200">Marketing (Meta Pixel) e conversioni</span><Switch data-testid="cookie-marketing-switch" checked={c.marketing} onCheckedChange={(v) => setC((x) => ({ ...x, marketing: v }))} /></div>
            </div>
          )}
          <div className="mt-4 flex flex-wrap gap-2">
            <button data-testid="cookie-accept-all" onClick={() => commit({ analytics: true, marketing: true })} className="h-10 px-4 rounded-full bg-[#ff5500] text-white text-sm font-medium hover:bg-[#ff6a1f] transition-colors">Accetta tutti</button>
            <button data-testid="cookie-reject" onClick={() => commit({ analytics: false, marketing: false })} className="h-10 px-4 rounded-full border border-white/15 text-white text-sm hover:bg-white/5 transition-colors">Solo necessari</button>
            {prefs
              ? <button data-testid="cookie-save-prefs" onClick={() => commit(c)} className="h-10 px-4 rounded-full text-sm text-[#7fd6fb] hover:text-white">Salva scelte</button>
              : <button data-testid="cookie-customize" onClick={() => setPrefs(true)} className="h-10 px-4 rounded-full text-sm text-slate-300 hover:text-white">Personalizza</button>}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
